import { Component, Input } from '@angular/core';
import { DynFormBase } from '../../../common-shared-module/model/dyn-form/dyn-form.model';
import { DynFormSectionBase } from '../../../common-shared-module/model/dyn-form/dyn-form-section.model';
import { DynFormSectionType } from '../../../common-shared-module/model/dyn-form/dyn-form-section.enum';
import { Router } from '@angular/router';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDivider, MatDividerModule } from '@angular/material/divider'
import { CdkDragDrop, CdkDragEnd, CdkDragStart, DragDropModule, moveItemInArray } from '@angular/cdk/drag-drop'
import { CommonModule } from '@angular/common';
import { DynFormService } from '../../../common-shared-module/services/dyn-form/dyn-form.service';
import { PageScrollContentComponent } from '../../../common-shared-module/components/page-scroll-content/page-scroll-content.component';
import { OverlayRef } from '@angular/cdk/overlay';

@Component({
    selector: 'app-form-editor-section-selector',
    templateUrl: './form-editor-section-selector.component.html',
    styleUrl: './form-editor-section-selector.component.scss',
    standalone: true,
    imports: [
        MatTooltipModule, MatDividerModule,

        PageScrollContentComponent,
        
        CommonModule, DragDropModule
    ]
})
export class FormEditorSectionSelectorComponent {

    @Input({ required: true }) dynForm!: DynFormBase
    @Input({ required: true }) dynFormSection!: DynFormSectionBase

    overlayRef!: OverlayRef

    onDD: boolean = false

    constructor(private router: Router, private dynFormService: DynFormService) { }
    
    startDD($event: CdkDragStart) {
        this.onDD = true
    }

    endDD($event: CdkDragEnd) {
        this.onDD = false
    }

    headerSections(): DynFormSectionBase[] {
        return this.dynForm ? this.dynForm.sectionsByType(DynFormSectionType.HEADER).sort(DynFormSectionBase.sortFn) : []
    }

    middleSections(): DynFormSectionBase[] {
        return this.dynForm ? this.dynForm.sectionsByType(DynFormSectionType.MIDDLE).sort(DynFormSectionBase.sortFn) : []
    }

    footerSections(): DynFormSectionBase[] {
        return this.dynForm ? this.dynForm.sectionsByType(DynFormSectionType.FOOTER).sort(DynFormSectionBase.sortFn) : []
    }

    goTo(section: DynFormSectionBase) {

        if (this.dynFormSection.id == section.id) {
            return
        }

        if (this.overlayRef) {
            this.overlayRef.dispose()
        }

        //this.dynFormSection = section
        this.router.navigateByUrl(`?procedureFormId=${this.dynForm.procedureFormId}&sectionId=${section.id}`)
    }

    dropSection($event: CdkDragDrop<DynFormSectionBase[]>) {
        let firstIndex = $event.container.data[0].order

        moveItemInArray($event.container.data, $event.previousIndex, $event.currentIndex)

        let res = []
        for (let i = 0; i < $event.container.data.length; i++) {
            const element = $event.container.data[i]
            element.order = firstIndex++
            res.push({ id: element.id, order: element.order })
        }

        this.dynFormService.putFormSectionOrder(res).subscribe()
    }

}
